import './PredictionsPage.scss';
import React, { useState, useMemo } from "react";
import Prediction from './Prediction.js';
import Spinner from '../../Spinner.js';
import FlatList from 'flatlist-react/lib/index.js';
import predictionIcon from '../../../assets/icons/alert-png.png';
import { useSensorDataContext } from '../../../contexts/SensorDataContext.js';
import { useUserContext } from '../../../contexts/UserContext.js';
import refreshIcon from '../../../assets/icons/refresh-icon.png';

export default function PredictionsPage(props) {
    const {
        getToken
    } = useUserContext();

    const {
        predictions,
        getPredictions
    } = useSensorDataContext();
    
    const { 
        panel, 
        setPanel, 
        map,
        user,
        setUser,
        area
    } = props;

    const [refreshing, setRefreshing] = useState(false);
    const [search, setSearch] = useState('');

    const filteredPredictions = useMemo(() => {
        if (!predictions) return [];
        return predictions.filter(prediction => {
            // Convert fire_id to string if it's not already, and handle null/undefined
            const fireId = prediction.fire_id ? String(prediction.fire_id) : '';
            return fireId.toLowerCase().includes(search.toLowerCase());
        });
    }, [predictions, search]);

    const renderPredictionRow = (prediction) => {
        return (
            <Prediction 
                prediction={prediction} 
                panel={panel} 
                setPanel={setPanel}
                map={map}
                user={user}
                setUser={setUser}
            />
        );
    }

    return (
        <div className='predictions-page'>
        <div className='predictions-page-title'>
            {/* <img src={predictionIcon} className='predictions-page-title-icon'/> */}
            <div className='predictions-page-title-text'>Wildire Predictions</div>
        </div>
        <div className='predictions-page-description'>Real-time wildfire predictions driven by cutting-edge AI and machine learning algorithms, enabling proactive responses and empowering communities with accurate, actionable insights to mitigate risks effectively.</div>
        {predictions ?
        <div className='predictions-page-content'>
            <div className='predictions-page-search'>
                <input
                    type="text"
                    placeholder="Search by Prediction ID"
                    className="predictions-page-search-input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>
            <div className='predictions-page-content-list-title'>
              <div className='predictions-page-content-list-title-text'>{`Predictions (${filteredPredictions.length})`}</div>
              <img 
                src={refreshIcon} 
                className='predictions-page-content-list-title-refreshing'
                style={{
                    transition: 'transform 0.5s ease',
                    transform: refreshing ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
                onClick={() => {
                    getToken().then((token) => {
                        getPredictions(map, token, setRefreshing)
                    }).catch((err) => console.log('error getting token', err));
                }}
            />
            </div>
            <div className='predictions-page-content-list'>
                {refreshing ?
                <Spinner />
                :
                <FlatList
                    list={filteredPredictions}
                    renderItem={renderPredictionRow}
                    renderOnScroll
                    renderWhenEmpty={() => (
                      <div style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        padding: '2rem',
                        textAlign: 'center',
                        color: '#666'
                      }}>
                        <div style={{ fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>
                          No predictions found
                        </div>
                        <div style={{ fontSize: '0.9rem' }}>
                          Try adjusting your search criteria or check back later
                        </div>
                      </div>
                    )}
                />
                }
            </div>
        </div>
        :
        <>
            <br></br>
            <Spinner />
        </>}
    </div>
    );
}